import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import SectionTitle from '../home-section-title';
import HomeCultureTitle from './home-culture-title';
import Image from 'gatsby-image';
import Reveal from '../../reveal';
import RevealEdges from '../../animations/reveal-edges';
import RevealSlideDown from '../../animations/reveal-slide-down';
import styles from './home-culture.module.css';

const CultureImage = props => {
  const { culture, animation, isInView } = props;

  return (
    <div
      className={styles.image}
      style={{
        position: 'relative',
        opacity: animation.opacity,
        transform: animation.transform,
      }}
    >
      <RevealEdges isInView={isInView} />
      <Image
        className={styles.image}
        outerWrapperClassName={styles.imageOuterWrapper}
        sizes={culture.localFile.childImageSharp.sizes}
        backgroundColor={true}
        alt={'Culture'}
      />
    </div>
  );
};

const CultureLink = props => {
  const { animation } = props;
  return (
    <Link to="/about" className={styles.learnMore} style={animation}>
      It’s the JK Way ›
    </Link>
  );
};

const HomeCultureContent = props => {
  const { isInView } = props;

  const settings = {
    sectionTitle: 'Our Culture',
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.message}>
            <SectionTitle
              sectionName={settings.sectionTitle}
              isInView={isInView}
            />
            <RevealSlideDown isInView={isInView}>
              <HomeCultureTitle />
            </RevealSlideDown>
            <RevealSlideDown isInView={isInView} delay={400}>
              <CultureLink />
            </RevealSlideDown>
          </div>
          <RevealSlideDown isInView={isInView}>
            <CultureImage {...props} />
          </RevealSlideDown>
        </div>
      </div>
    </div>
  );
};

const HomeCulture = props => {
  return (
    <Reveal>
      <HomeCultureContent {...props} />
    </Reveal>
  );
};

CultureImage.propTypes = {
  animation: PropTypes.object,
  culture: PropTypes.object,
  isInView: PropTypes.bool,
};

export default HomeCulture;



// WEBPACK FOOTER //
// ./src/components/home/home-culture/index.js